import { render, staticRenderFns } from "./brandAuthorizing.vue?vue&type=template&id=7567e464&scoped=true&"
import script from "./brandAuthorizing.vue?vue&type=script&lang=js&"
export * from "./brandAuthorizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567e464",
  null
  
)

export default component.exports